import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/portal/auth/AuthContext';
import { ApiError } from '@/portal/api/client';

const LOGO = '/assets/didiers-logo.svg';

export function ChangePasswordPage() {
  const { changePassword, mustChangePassword } = useAuth();
  const navigate = useNavigate();

  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (busy) return;
    setError(null);
    if (next.length < 8) {
      setError('New password must be at least 8 characters.');
      return;
    }
    if (next !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setBusy(true);
    try {
      await changePassword(current, next);
      navigate('/portal', { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Could not change your password.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="portal">
      <div className="pl-login">
        <form className="pl-login-card" onSubmit={onSubmit}>
          <div className="pl-login-head">
            <img src={LOGO} alt="Didier's Patisserie" />
          </div>
          <div className="pl-login-body">
            <h1>{mustChangePassword ? 'Choose a new password' : 'Change password'}</h1>
            <p className="sub">
              {mustChangePassword
                ? 'For security, please set your own password before continuing.'
                : 'Update the password for your portal account.'}
            </p>

            {error && <div className="pl-login-error">{error}</div>}

            <div className="pl-field">
              <label htmlFor="cp-current">Current password</label>
              <input
                id="cp-current"
                type="password"
                autoComplete="current-password"
                value={current}
                onChange={(e) => setCurrent(e.target.value)}
                required
              />
            </div>
            <div className="pl-field">
              <label htmlFor="cp-new">New password</label>
              <input
                id="cp-new"
                type="password"
                autoComplete="new-password"
                placeholder="At least 8 characters"
                value={next}
                onChange={(e) => setNext(e.target.value)}
                required
              />
            </div>
            <div className="pl-field">
              <label htmlFor="cp-confirm">Confirm new password</label>
              <input
                id="cp-confirm"
                type="password"
                autoComplete="new-password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
              />
            </div>
            <button
              type="submit"
              className="pl-btn dark"
              style={{ width: '100%', justifyContent: 'center', padding: '12px' }}
              disabled={busy}
            >
              {busy ? 'Saving…' : 'Save password'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
